import React from "react";
import classNames from "classnames";
import Contexts from "../contexts";
import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Divider from "@material-ui/core/Divider";
import Popper from "@material-ui/core/Popper";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import TR_FLAG from "../assets/img/tr.svg";
import EN_FLAG from "../assets/img/en.svg";
import {
    logOut,
    getLanguage,
    setLanguage
  } from "../api";
import customDropdownStyle from "assets/jss/material-kit-react/components/customDropdownStyle.jsx";

class LanguageMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  handleClick() {
    this.setState(state => ({ open: !state.open }));
  }
  handleClose(param) {
    this.setState({ open: false });
    if (param) {
      this.handleMenuAction(param);
    }
  }
  handleCloseAway = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ open: false });
  };
  handleMenuAction(lang) {
    setLanguage(lang);
   const textContexts = {...this.props.baseContext.baseContext.textContexts};
   this.props.baseContext.baseContext.textContexts = [];
   this.props.baseContext.setBase(this.props.baseContext.baseContext);
   setTimeout(()=>{
    this.props.baseContext.baseContext.textContexts = textContexts;
    this.props.baseContext.setBase(this.props.baseContext.baseContext);

   }, 100);

  }
  getItems() {
      return [
        {
          lang: "tr",
          title: "Türkçe"
        },
        {
          lang: "en",
          title: "English"
        },
      ];

  }
  render() {
    const { open } = this.state;
    const dropdownList = this.getItems();

    const {
      classes,
      dropup,
      dropdownHeader,
      hoverColor,
      rtlActive,
      noLiPadding,
      isMobile,
    } = this.props;

    const dropdownItem = classNames({
      [classes.dropdownItem]: true,
      [classes[hoverColor + "Hover"]]: true,
      [classes.noLiPadding]: noLiPadding,
      [classes.dropdownItemRTL]: rtlActive
    });
    return (
      <div>
        <div>
          <IconButton
            buttonRef={node => {
              this.anchorEl = node;
            }}
            onClick={this.handleClick}
          >
              <img style={{ width: isMobile ? 24 : 32}} src={getLanguage() === "tr" ? TR_FLAG : EN_FLAG} alt="profile"/>
          </IconButton>
        </div>
        <Popper
          open={open}
          anchorEl={this.anchorEl}
          transition
          disablePortal
          placement={
            dropup
              ? "top-start"
              : "bottom-start"
          }
          className={classNames({
            [classes.popperClose]: !open,
            [classes.pooperResponsive]: true
          })}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              in={open}
              id="menu-list"
              style={
                dropup
                  ? { transformOrigin: "0 100% 0" }
                  : { transformOrigin: "0 0 0" }
              }
            >
              <Paper className={classes.dropdown}>
                <ClickAwayListener onClickAway={this.handleCloseAway}>
                  <MenuList role="menu" className={classes.menuList}>
                    {dropdownHeader !== undefined ? (
                      <MenuItem
                        onClick={this.handleClose}
                        className={classes.dropdownHeader}
                      >
                        {dropdownHeader}
                      </MenuItem>
                    ) : null}
                    {dropdownList.map((prop, key) => {
                      if (prop.divider) {
                        return (
                          <Divider
                            key={key}
                            onClick={this.handleClose}
                            className={classes.dropdownDividerItem}
                          />
                        );
                      }
                      return (
                        <MenuItem
                          key={key}
                          onClick={() => this.handleClose(prop.lang)}
                          className={dropdownItem}
                        >
                          {prop.title}
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}
export default withStyles(customDropdownStyle)(LanguageMenu);
